
import React, { useEffect } from "react";
import { Route, useHistory, Redirect } from "react-router-dom";
import { DashboardLayout } from "./layouts";
import { Routes } from "./constants";
import { injectModels } from "./redux/injectModels";

const CustomAdminRoute = ({ component: Component, ...rest }) => {
  const history = useHistory();

  const isSubs = localStorage.getItem("Subscription_status");

  console.log("Route Render");
  console.log("Subscription_status =", isSubs);
  console.log("expires_in =", localStorage.getItem("expires_in"));
  console.log("sub_expire_date =", localStorage.getItem("sub_expire_date"));
  console.log("orgId =", localStorage.getItem("orgId"));

  const logoutUser = () => {
    rest.auth.logout();
    localStorage.clear();
    history.replace(Routes.LOGIN);
  };

  const checkExpiry = () => {
    const token = localStorage.getItem("accessToken");
    const subscriptionExpiry = localStorage.getItem("sub_expire_date");
    const orgId = localStorage.getItem("orgId");

    const now = new Date();
    let isExpired = false;

    if (token) {
      try {
        const parts = token.split('.');
        if (parts.length === 3) {
          const base64Url = parts[1];
          const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
          const jsonPayload = decodeURIComponent(
            atob(base64)
              .split('')
              .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
              .join('')
          );
          const payload = JSON.parse(jsonPayload);
          if (payload.exp) {
            const expirationTime = new Date(payload.exp * 1000);
            console.log("NOW =", now);
            console.log("SESSION EXPIRY FROM JWT =", expirationTime);
            if (now >= expirationTime) {
              isExpired = true;
            }
          }
        }
      } catch (e) {
        console.error("Failed to decode token expiration:", e);
      }
    }

    // Fallback to local storage expires_in if JWT parsing didn't decide
    if (!isExpired) {
      const sessionExpiry = localStorage.getItem("expires_in");
      if (sessionExpiry) {
        const sessionTime = new Date(sessionExpiry.replace(" ", "T") + "Z");
        console.log("NOW =", now);
        console.log("SESSION EXPIRY FROM LOCALSTORAGE =", sessionTime);
        if (now >= sessionTime) {
          isExpired = true;
        }
      }
    }

    if (isExpired) {
      console.log("SESSION EXPIRED");
      logoutUser();
      return;
    }

    // Organisation user => ignore subscription expiry
    const isOrganisationUser =
      orgId !== null &&
      orgId !== "" &&
      orgId !== "null";

    if (!isOrganisationUser && subscriptionExpiry) {
      const subscriptionTime = new Date(subscriptionExpiry.replace(" ", "T") + "Z");
      console.log("SUB =", subscriptionTime);
      if (now >= subscriptionTime) {
        console.log("SUBSCRIPTION EXPIRED");
        logoutUser();
      }
    }
  };

  useEffect(() => {
    checkExpiry();

    const timer = setInterval(checkExpiry, 60000);

    const handleVisibility = () => {
      if (!document.hidden) {
        checkExpiry();
      }
    };

    document.addEventListener("visibilitychange", handleVisibility);

    return () => {
      clearInterval(timer);
      document.removeEventListener("visibilitychange", handleVisibility);
    };
  }, []);

  return (
    <Route
      {...rest}
      render={(props) =>
        isSubs == 1 ? (
          <DashboardLayout>
            <Component {...props} />
          </DashboardLayout>
        ) : (
          <Redirect to={Routes.LOGIN} />
        )
      }
    />
  );
};

export default injectModels(["auth"])(CustomAdminRoute);
